export class ApiException extends Error {

    constructor(url, status, data) {
        const message = typeof data === 'string'
            ? data
            : (data?.detail || data?.message || `Error ${status}`)
        super(message);
        this.url = url;
        this.status = status;
        this.data = data;
        this.message = message;
    }
}

export class RecordNotFound extends ApiException {
    constructor(url, status, message) {
        super(url, status, message);
    }
}

export class PermissionDenied extends ApiException {
    constructor(url, status, message) {
        super(url, status, message);
    }
}

export class ValidationError extends ApiException {
    constructor(url, status, message) {
        super(url, status, message)
    }

    getCode() {
        return this.data.code
    }

    getData() {
        return this.data.error_data
    }

    getPrettyMessage() {
        let errors = []
        for (const [key, value] of Object.entries(this.data)) {
            if (Array.isArray(value)) {
                value.forEach((item) => {
                    if (typeof item === 'object')
                        errors.push(`${key}: ${this.getPrettyMessage(item)}`)
                    else if (typeof item === 'string')
                        errors.push(`${key}: ${item}`)
                })
            } else if (typeof value === 'object')
                errors.push(`${key}: ${this.getPrettyMessage(value)}`)
            else if (typeof value === 'string')
                errors.push(`${key}: ${value}`)
        }
        return errors.join('<br>')
    }

    getAsDict(message) {
        if (message === undefined)
            message = this.data

        let errors = {}
        for (const [key, value] of Object.entries(message)) {
            if (Array.isArray(value)) {
                value.forEach((item) => {
                    if (typeof item === 'object') {
                        let subs = this.getAsDict(item)
                        for (const [subKey, value] of Object.entries(subs))
                            errors[key+'.'+subKey] = value
                    }
                    else if (typeof item === 'string')
                        errors[key] = item
                })
            } else if (typeof value === 'object') {
                let subs = this.getAsDict(value)
                for (const [subKey, value] of Object.entries(subs))
                    errors[key+'.'+subKey] = value
            }
            else if (typeof value === 'string')
                errors[key] = value
        }
        return errors
    }
}

export class Notification extends Error {

    constructor(message, notification_type) {
        super(message);
        this.type = notification_type;
        this.message = message;
    }
}


export class SuccessNotification extends Notification {
    constructor(message) {
        super(message, 'success')
    }
}

export class DangerNotification extends Notification {
    constructor(message) {
        super(message, 'danger')
    }
}

export class ErrorNotification extends Notification {
    constructor(message) {
        super(message, 'danger')
    }
}

export class MultipleFacesError extends ApiException {
    constructor(url, status, message, faces) {
        super(url, status, message)
        this.faces = faces || []
    }

    getFaces() {
        return this.faces
    }

    hasFaces() {
        return this.faces.length > 0
    }
}